<template>
  <b-row>
    <b-col sm="12">
      <b-card header="Datos de la cuenta">
        <b-col sm="6">
          <b-form @submit.prevent="send()">
            <strong>Información personal</strong>
            <div class="form-group">
              <label for>Nombre</label>
              <input
                type="text"
                v-model="user.name"
                class="form-control"
                required
              />
            </div>
            <div class="form-group">
              <label for>Apellido</label>
              <input
                type="text"
                v-model="user.last_name"
                class="form-control"
                required
              />
            </div>
            <div class="form-group">
              <label for>Email</label>
              <input
                type="email"
                v-model="user.email"
                class="form-control"
                required
              />
            </div>
            <div class="form-group">
              <label for>Celular</label>
              <input type="text" v-model="user.mobile" class="form-control" />
            </div>
            <div class="form-group">
              <label>
                <input type="checkbox" v-model="user.active" /> Activo
              </label>
            </div>
            <div v-if="!company_id" class="form-group">
              <label for>Perfil</label>
              <select
                v-model="user.role_id"
                class="form-control"
                required
                @change="selectProfile"
              >
                <!--@change="providerProfile(user.role_id)"-->
                <option value>Seleccione perfil</option>
                <option v-for="(role, k) in roles" :key="k" :value="role.id">{{
                  role.name
                }}</option>
              </select>
            </div>
            <div v-if="isDriver || isProvider" class="form-group">
              <label for>Empresa de transporte</label>
              <select v-model="user.provider_id" class="form-control" required>
                <option :value="null">Seleccione empresa</option>
                <option
                  v-for="(provider, key) in providers"
                  :key="key"
                  :value="provider.id"
                  >{{ provider.name }}
                </option>
              </select>
            </div>
            <div v-if="isDriver" class="form-group">
              <label for>Tipo de conductor</label>
              <select
                v-model="user.driver_mode_id"
                class="form-control"
                required
              >
                <option :value="null">Seleccione</option>
                <option
                  v-for="(driver_mode, key) in driver_modes"
                  :key="key"
                  :value="driver_mode.id"
                  >{{ driver_mode.name }}
                </option>
              </select>
            </div>
            <div class="form-group" v-if="!user_id">
              <label for>
                <input type="checkbox" v-model="random_pass" /> Generar
                contraseña aleatoria
              </label>
            </div>
            <div class="form-group" v-if="!random_pass">
              <label for>Contraseña</label>
              <input
                type="password"
                v-model="user.password"
                class="form-control"
              />
              <small class="form-text text-muted" v-if="user_id"
                >Dejar en blanco si desea mantener contraseña actual.</small
              >
            </div>
            <hr v-if="isDriver" />
            <strong v-if="isDriver">Información de conductor</strong>
            <div v-if="isDriver">
              <div class="form-group">
                <label for>Brevete</label>
                <input
                  type="text"
                  v-model="user.license_number"
                  class="form-control"
                />
              </div>
              <div v-for="(item, k) in userFields" :key="k" class="form-group">
                <label for>{{ item.label }}</label>
                <br />
                <date-picker
                  v-model="user[item.field]"
                  lang="es"
                  type="date"
                  required
                  format="DD/MM/YYYY"
                ></date-picker>
              </div>
              <b-row class="form-group">
                <b-col sm="12">
                  <label for>Clientes restringidos de acceso</label>
                  <v-select
                    multiple
                    v-model="user.companies"
                    label="name"
                    :options="companies"
                    :on-change="setCompanies"
                  ></v-select>
                </b-col>
              </b-row>
            </div>
            <div class="form-group">
              <input type="submit" value="Enviar" class="btn btn-primary" />
            </div>
          </b-form>
        </b-col>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import api from "@/helpers/api";
import constants from "@/constants";
import userFields from "@/constants/user";
import moment from "moment";

export default {
  props: ["user_id", "company_id"],
  data() {
    return {
      user: {
        companies: []
      },
      random_pass: false,
      roles: [],
      role_selected: { code: null },
      companies: [],
      providers: [],
      driver_modes: [],
      driver_role: {},
      provider_role: {},
      userFields,
      profile_id: null,
      constants
    };
  },
  mounted() {
    api.get("/roles").then(response => {
      this.roles = response.roles.filter(
        role => role.code !== constants.SOLICITANTE
      );
      this.driver_role = response.roles.find(
        role => role.code === constants.CONDUCTOR
      );
      this.provider_role = response.roles.find(
        role => role.code === constants.PROVEEDOR
      );
      const role_cli = response.roles.find(
        role => role.code === constants.SOLICITANTE
      );
      if (!this.user_id)
        this.user.role_id = this.company_id ? role_cli.id : null;
    });
    api.get("/providers").then(response => {
      this.providers = response.providers;
    });
    api.get("/companies").then(response => {
      this.companies = response.companies;
    });
    api.get("/driver_modes").then(response => {
      this.driver_modes = response.driver_modes;
    });

    if (this.user_id) {
      api.get(`/user/${this.user_id}`).then(response => {
        this.user = response.user;
      });
    } else {
      this.user.company_id = this.company_id ? this.company_id : null;
    }
  },
  computed: {
    isDriver() {
      const { user, driver_role, role_selected } = this;
      console.log(role_selected);
      return (
        user.role_id === driver_role.id ||
        (role_selected && role_selected.code === constants.CONDUCTOR)
      );
    },
    isProvider() {
      const { user, provider_role, role_selected } = this;
      return (
        user.role_id === provider_role.id ||
        (role_selected && role_selected.code === constants.PROVEEDOR)
      );
    }
  },
  methods: {
    generatePassword() {
      return [...Array(6)]
        .map(i => (~~(Math.random() * 36)).toString(36))
        .join("");
    },
    setDatetime(date) {
      return date ? moment(date).format("YYYY-MM-DD 23:59:59") : null;
    },
    setCompanies(obj) {
      this.user.companies = obj ? obj : [];
    },
    send() {
      const { user } = this;

      userFields.map(item => {
        this.user[item.field] = this.setDatetime(user[item.field]);
      });

      if (this.user_id) {
        api.put(`/users/${this.user.id}`, this.user).then(
          response => {
            this.$toastr.success(`Personal actualizado`, "Editar personal", {
              positionClass: "toast-top-center",
              closeButton: true
            });
            //this.$router.push('/rrhh/users')
            this.$router.go(-1);
          },
          error => {
            this.$toastr.error(error.message, "Crear personal", {
              positionClass: "toast-top-center",
              closeButton: true
            });
          }
        );
      } else {
        if (this.random_pass) this.user.password = this.generatePassword();

        api.post("/users", this.user).then(
          response => {
            this.$toastr.success(`Personal creado`, "Crear personal", {
              positionClass: "toast-top-center",
              closeButton: true
            });
            //this.$router.push('/rrhh/users')
            this.$router.go(-1);
          },
          error => {
            this.$toastr.error(error.message, "Crear personal", {
              positionClass: "toast-top-center",
              closeButton: true
            });
          }
        );
      }
    },
    selectProfile(ev) {
      this.role_selected = this.roles.find(r => r.id == ev.target.value);
    }
  }
};
</script>
